import { useMemo } from "react";
import { useLocation } from "react-router-dom";

type ViewType = {
  isBinView: boolean;
  isProductView: boolean;
  isProductsView: boolean;
  isHoldsPage: boolean;
  viewType: "bin" | "product" | "products" | "";
};

/**
 * Hook that returns the type of inventory view, based on the path of the location.
 */
export function useViewType() {
  const { pathname } = useLocation();

  const view = useMemo(() => {
    let viewType: ViewType["viewType"] = "";
    if (pathname.includes("/bin")) {
      viewType = "bin";
    } else if (pathname.includes("/product/")) {
      viewType = "product";
    } else if (pathname.includes("/product")) {
      viewType = "products";
    }

    const isBinView = viewType === "bin";
    const isProductView = viewType === "product";
    const isProductsView = viewType === "products";
    const isHoldsPage = pathname.includes("/holds");
    return {
      isBinView,
      isProductView,
      isProductsView,
      isHoldsPage,
      viewType
    };
  }, [pathname]);

  return view;
}
